import { computed, nextTick } from 'vue';
import { storeToRefs } from 'pinia';

import useModalStore from '@global/stores/useModalStore';

import useShopContentStore from '@global/stores/useShopContentStore';
import useAlert from '@global/composable/useAlert';

const shopContentStore = useShopContentStore();
const { selectedFoodSpec } = storeToRefs(shopContentStore);
const modalStore = useModalStore();
const { openModal, closeModal } = modalStore;

const { alertDialog } = useAlert();

function IsPreOrderFactory(item) {
  if (item) {
    return item.PreOrder ? '預購' : '現貨';
  }
  return null;
}

function IsMapSellPriceFactory(item) {
  if (!item) return null;
  return item.EventPrice > 0 && item.EventPrice < item.SellPrice ? item.EventPrice : item.SellPrice;
}

function IsHasCheaperPriceFactory(item) {
  if (!item) return null;
  return item.EventPrice > 0 || item.SellPrice < item.OriginPrice;
}

function IsProductTemperatureFactory(item) {
  if (!item) return null;
  return item.Temperature === 0 ? '常溫' : item.Temperature === 1 ? '冷藏' : '冷凍';
}

function IsNoEventFactory(item) {
  if (!item) return false;
  return item.Events.length === 0 && item.GiftEvents.length === 0 && item.LimitAmount === 0;
}

function IsBtnStyleFactory(item) {
  if (!item) return null;
  if (item.IsPreShow) {
    return 'btn-secondary disabled';
  }
}

function IsDescriptionFactory(item) {
  if (!item) return null;
  if (item.IsPreShow) {
    return '即將開賣';
  }
  return '加入購物車';
}

const mapOriginPrice = computed(() => {
  if (selectedFoodSpec.value) {
    return (
      selectedFoodSpec.value.Product?.SellPrice !== selectedFoodSpec.value.Product?.OriginPrice ||
      selectedFoodSpec.value.Product?.EventPrice > 0
    );
  }
  return null;
});

async function clickToCart(func) {
  try {
    const resolve = await func();
    if (resolve === undefined) return;
    const { code } = resolve;

    switch (code) {
      case 200:
        openModal('Add2CartSuccess');
        setTimeout(() => {
          closeModal();
        }, 2000);
        break;
      case 205:
        alertDialog.alert('商品已售完', () => {
          window.location.reload();
        });
        break;
      default:
        break;
    }
  } catch (error) {
    console.log(error);
  }
}

function useSpec() {
  return {
    mapOriginPrice,

    IsPreOrderFactory,
    IsMapSellPriceFactory,
    IsHasCheaperPriceFactory,
    IsProductTemperatureFactory,
    IsNoEventFactory,
    IsBtnStyleFactory,
    IsDescriptionFactory,

    clickToCart,
  };
}

export default useSpec;
